import classNames from 'classnames';
import styles from './ImagePreview.module.css';
import { IonImg, IonText } from '@ionic/react';
import { SimpleCSSColor } from './Forms/SimpleCSSColorInput';

export type ImagePreviewType = 'logo' | 'cover';

export interface ImagePreviewProps {
	type: ImagePreviewType;
	image?: string;
	bgColor?: SimpleCSSColor;
}

export function ImagePreview({ type, image, bgColor }: ImagePreviewProps): JSX.Element {
	return (
		<div className={styles.ImagePreview}>
			<IonText className={styles.previewTitle}>Preview {type}</IonText>
			<div className={type === 'cover' ? styles.cover : styles.logo}>
				{image && type === 'cover' && <IonImg alt={type} src={image} className={styles.coverImage} />}
				{image && type === 'logo' && (
					<>
						<div className={classNames(styles.theme, styles.light)}>
							<div className={styles.logoWrapper} style={{ background: `${bgColor}` }}>
								<IonImg alt={type} src={image} />
							</div>
							<IonText className={classNames(styles.text, styles.lightText)}>Light theme</IonText>
						</div>
						<div className={classNames(styles.theme, styles.dark)}>
							<div className={styles.logoWrapper} style={{ background: `${bgColor ?? 'transparent'}` }}>
								<IonImg alt={type} src={image} />
							</div>
							<IonText className={classNames(styles.text, styles.darkText)}>Dark theme</IonText>
						</div>
					</>
				)}
			</div>
		</div>
	);
}
